import { render, staticRenderFns } from "./BankPicker.vue?vue&type=template&id=1b987204&scoped=true"
import script from "./BankPicker.vue?vue&type=script&lang=js"
export * from "./BankPicker.vue?vue&type=script&lang=js"
import style0 from "./BankPicker.vue?vue&type=style&index=0&id=1b987204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b987204",
  null
  
)

export default component.exports